let Dom = {};

Dom.isElementInViewPoint = function(el) {
    let domRect = el.getBoundingClientRect();
    let width = window.innerWidth;
    let height = window.innerHeight;
    let top = domRect.top <= height && domRect.top >= 0;
    let bottom = domRect.bottom <= height;
    let left = domRect.left <= width && domRect.left >= 0;
    let right = domRect.right <= width;

    return top && bottom && left && right;
}

export default Dom;